module.exports = __webpack_public_path__ + "img/addShopcars.815165d3.svg";